import React, { Component } from 'react'
import styled from 'styled-components'
import { Col } from 'react-flexbox-grid'
import ReactDOM from 'react-dom'
import { ShadowBox } from '@ubiwherenpm/adene-ui-components'

// TODO: this needs refactor
// Move component to UI package
/* eslint-disable camelcase */
const InfoBox = ({ designation, tax_id, address, website, email, phone_number, style, cRef, closeHandler, isCompany, business_website, business_phone_number, business_email }) => (
  <Info style={style} onClick={e => e.stopPropagation()} ref={cRef}>
    <InfoCol>
      <Designation>{designation}</Designation>
      {tax_id &&
        <div>
          <ContactItem>NIPC:</ContactItem>
          <span>{tax_id}</span>
        </div>
      }
      {address &&
        <div>
          <ContactItem>Morada:</ContactItem>
          <span style={{display: 'inline-block'}}>
            { address.split('\r\n').map(line => (<span>{line}<br /></span>)) }</span>
        </div>
      }
    </InfoCol>
    <InfoCol style={{ position: 'relative' }}>
      <ContactTitle>Contactos</ContactTitle>
      { !isCompany && website &&
        <div>
          <ContactItem>Website:</ContactItem>
          <ContactLink target='_blank' href={website}>
            {website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')}
          </ContactLink>
        </div>
      }
      { isCompany && business_website &&
        <div>
          <ContactItem>Website:</ContactItem>
          <ContactLink target='_blank' href={business_website}>
            {business_website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')}
          </ContactLink>
        </div>
      }

      { !isCompany && email &&
        <div>
          <ContactItem>Email:</ContactItem>
          <ContactLink href={`mailto:${email}`}>
            {email}
          </ContactLink>
        </div>
      }
      { isCompany && business_email &&
        <div>
          <ContactItem>Email:</ContactItem>
          <ContactLink href={`mailto:${business_email}`}>
            {business_email}
          </ContactLink>
        </div>
      }

      { !isCompany && phone_number &&
        <div>
          <ContactItem>Telefone:</ContactItem>
          <ContactLink href={`tel:${phone_number}`}>
            {phone_number}
          </ContactLink>
        </div>
      }
      {isCompany && business_phone_number &&
        <div>
          <ContactItem>Telefone:</ContactItem>
          <ContactLink href={`tel:${business_phone_number}`}>
            {business_phone_number}
          </ContactLink>
        </div>
      }
      <Close onClick={closeHandler} />
    </InfoCol>
  </Info>
)
export default class ResultItem extends Component {
  constructor () {
    super()
    this.boxRef = null
    this.infoRef = null
    this.wrapperRef = null

    this.getBoxRef = this.getBoxRef.bind(this)
    this.getInfoRef = this.getInfoRef.bind(this)
    this.getWrapperRef = this.getWrapperRef.bind(this)
  }

  componentWillReceiveProps ({ opened }) {
    setTimeout(() => {
      this.wrapperRef.style.height = opened
      ? `${this.boxRef.clientHeight + this.infoRef.clientHeight}px` : ''
    }, 10)
  }

  getBoxRef (ref) {
    this.boxRef = ReactDOM.findDOMNode(ref)
  }

  getInfoRef (ref) {
    this.infoRef = ReactDOM.findDOMNode(ref)
  }

  getWrapperRef (ref) {
    this.wrapperRef = ReactDOM.findDOMNode(ref)
  }

  render () {
    const { designation, logo, opened, onClick, isCompany } = this.props
    const WrapperProps = {onClick, className: opened && 'info-opened'}
    const BoxProps = {className: opened && 'selected'}

    return (
      <Wrapper {...WrapperProps} ref={this.getWrapperRef}>
        <Box {...BoxProps} ref={this.getBoxRef} >
          <Logo src={logo} alt={designation} />
        </Box>
        <InfoBox {...this.props} cRef={this.getInfoRef} style={opened ? {}
          : { opacity: '0', display: 'none' }} closeHandler={onClick} isCompany={isCompany} />
      </Wrapper>
    )
  }
}

/* eslint-enable camelcase */

const Wrapper = styled(Col)`
  padding: 0 15px;
  margin-bottom: 35px;
  transition: all .6s ease;
`

const Box = styled(ShadowBox)`
  width: 100%;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover,
  &.selected {
    box-shadow: 0 0 6px 0 rgba(0,103,54,0.5);
  }

  @media screen and (max-width: 1024px) {
    height: 170px;
  }

  @media screen and (max-width: 768px) {
    height: 150px;
  }

  @media screen and (max-width: 425px) {
    height: 100px;
  }

`

const Logo = styled.img`
    width: 50%;

    @media screen and (max-width: 425px) {
      width: 75%;
    }
`

const Info = styled.div`
  width: 100%;
  max-width: 1200px;
  position: absolute;
  left: 0;
  padding: 50px;
  box-sizing: border-box;
  margin: 10px 0;
  display: flex;
  align-items: stretch;
  transition: all .6s ease, opacity: 0s;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: initial;
    padding: 25px;
  }

  @media screen and (max-width: 425px) {
    flex-direction: column;
    align-items: initial;
    padding: 25px;
  }
`
const ContactItem = styled.b`
  margin-right: 5px;
  vertical-align: top;
  @media screen and (max-width: 425px) {
    display: block;
    margin-top: 10px;
    font-size: 12px;
  }
`

const ContactLink = styled.a`
  color: #93C13E;
`

const InfoCol = styled.div`
  flex: 1;

  @media screen and (min-width: 568px) {

    &:first-child {
      padding-right: 50px;
    }

    &:last-child {
      border-left: 1px solid #BABABA;
      padding-left: 50px;
    }
  }
`

const Designation = styled.h2`
  color: #93C13E;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`

const ContactTitle = styled.h2`
  color: #676767;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`

const Close = styled.span`
border: 1px solid #BABABA;
flex: 0.05;
width: 24px;
height: 24px;
display: block;
text-align: center;
position: absolute;
cursor: pointer;
top: 0;
right: 0;

&:before {
  content: "✕";
  font-size: 20px;
  line-height: 24px;
  color: #BABABA;
  top: 1px;
  position: absolute;
  left: 0;
  width: 100%;
}
`



// WEBPACK FOOTER //
// ./src/components/ResultItem/index.js